import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'abc-contact-us',
  templateUrl: './abc-contact-us.component.html',
  styleUrls: ['./abc-contact-us.component.css']
})
export class AbcContactUsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
